import { NgModule } from '@angular/core';

import { ExcludeObjectsComponent } from '@app/authorized/project/exclude-objects/exclude-objects.component';
import { SharedModule } from '@app/shared';
//import { StringFormatPipe } from '@app/authorized/project/exclude-objects/stringFormat.pipe';

@NgModule({
    imports: [SharedModule],
    declarations: [ ExcludeObjectsComponent],
    entryComponents: [ExcludeObjectsComponent],
    exports: [ExcludeObjectsComponent]
})
export class ExcludeObjectModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/exclude-objects/exclude-object.module.ts